module.exports = class DateFormatterService {
    static formatToShortDate(isoString) {
      const date = new Date(isoString);
      const options = { month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    }
  };
  